var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInteractionDesign(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H35.9883C42.6157 0 47.9883 5.37258 47.9883 12V35.9883C47.9883 42.6157 42.6157 47.9883 35.9883 47.9883H12C5.37258 47.9883 0 42.6157 0 35.9883V12Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5796 24.5798L30.9894 30.9896",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6876 15.037C15.5966 14.9986 15.4962 14.9883 15.3993 15.0072C15.3024 15.0262 15.2133 15.0736 15.1435 15.1435C15.0737 15.2133 15.0263 15.3023 15.0073 15.3993C14.9883 15.4962 14.9987 15.5965 15.037 15.6875L21.5328 31.6761C21.5728 31.7729 21.6421 31.8546 21.7309 31.9099C21.8198 31.9653 21.9238 31.9913 22.0282 31.9845C22.1327 31.9776 22.2323 31.9382 22.3132 31.8718C22.3941 31.8054 22.4522 31.7153 22.4792 31.6142L24.0472 25.5351C24.1306 25.1802 24.3096 24.8549 24.5646 24.5944C24.8197 24.3338 25.1412 24.1481 25.4942 24.0571L31.6142 22.4791C31.7159 22.4527 31.8066 22.395 31.8735 22.3142C31.9405 22.2333 31.9803 22.1334 31.9873 22.0287C31.9942 21.9239 31.968 21.8196 31.9124 21.7306C31.8567 21.6416 31.7744 21.5724 31.6772 21.5327L15.6876 15.037Z",
    stroke: "#057DCD",
    strokeWidth: 1.9987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractionDesign);
export default __webpack_public_path__ + "static/media/Interaction Design.9e05d9430195892602f23b78b5a718b8.svg";
export { ForwardRef as ReactComponent };